import { handleSlotRenderEnded } from "./slot_render_ended"
import { hideIfEmpty } from "./hide_if_empty"
import { pushViewableImpressionToDataLayer } from "./viewable_impression"

export const registerListenersForAdLifecycleEvents = () => {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().addEventListener('slotRenderEnded', handleSlotRenderEnded)
    window.googletag.pubads().addEventListener('slotRenderEnded', hideIfEmpty)
    window.googletag.pubads().addEventListener('impressionViewable', pushViewableImpressionToDataLayer)
  })
}
